import { BehaviorSubject } from 'rxjs';
import { ToastConfig, ToastType } from './interface';

export class ToasterService {
  public addToastSubject = new BehaviorSubject<ToastConfig | undefined>(undefined);

  pop(type: ToastType | ToastConfig, title?: string, body?: string) {
    const toast = typeof type === 'string' ? { type, title, body } : type;

    this.addToastSubject.next(toast);
  }
}

// eslint-disable-next-line import/no-mutable-exports
export let toasterService = new ToasterService();

export function setToasterService(service: ToasterService) {
  toasterService = service;
}
